export default {
  dashboard: [],
  config: {},
  configForPanel: {},
  profile: {},
  polls: [],
  files: [],
  file: [],
  fileGrouping: [],
  filesTime: [],
  pollById: [],

  categories: [],
  categoryChilds: [],

  waitingTickets: [],
  answeredTickets: [],
  closedTickets: [],
  ticket: {},
  ticketCategories: [],

  units: [],

  images: [],
  image: [],
  deletedImages: [],

  videos: [],
  video: [],
  deletedVideos: [],

  sounds: [],
  sound: [],
  deletedSounds: [],

  posts: [],
  post: [],
  deletePosts: [],

  useless: false,

  approvedComments: [],
  unapprovedComments: [],
  comment: [],

  ///////////////////////////////////////////////////
  colors: [],
  designTypes: [],
  commodities: [],
  packings: [],
  packingInfo: [],
  machines: [],
  templates: [],
  productPrice: [],
  benefitsAndDeduction: [],

  bannerTypes: [],
  banners: [],
  sliders: [],

  socialNetworks: [],
  socialMedia: [],

  pages: [],
  page: [],

  posters: [],
  positions: [],

  menus: [],
  menu: [],

  boms: [],
  bom: {},

  workCalender: [],
  annualBase: [],
  unitPosition: [],
  Jobs: [],
  taxs: [],

  fiscalYear: [],
  banks: [],
  treeAccountInfo: [],
  accountInfo: [],

  inputOutputs: [],
  companyInfo: {},
  measurementUnits: [],

  widgets: [],
  widget: [],
  widgetItems: [],
  cars: [],
  car: [],
  saleTypes: [],
  saleType: [],
  transactions: [],
  factors: [],
  finishFactors: [],

  ordersSettings: [],
};
